import { useMutation, useQueryClient } from "@tanstack/react-query";

import { deletePartnersPartnerIDDocumentsPartnerDocumentID } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { PARTNERS_QUERY_KEYS } from "Partners/Api/Queries/queryKeys";

export function useDeletePartnerDocumentMutation(partnerID: string) {
  const queryClient = useQueryClient();

  const mutationFn = processResponse((partnerDocumentID: string) =>
    deletePartnersPartnerIDDocumentsPartnerDocumentID(
      partnerID,
      partnerDocumentID,
    ),
  );

  return useMutation({
    mutationFn,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: PARTNERS_QUERY_KEYS.documents(partnerID),
      });
    },
  });
}
